/**
 * Enum specifying font weights, typically applied to text elements.
 */
export enum FontWeight {
  None = '',
  Bold = 'bold',
  Light = 'light',
  Normal = 'normal'
}
